import { render, staticRenderFns } from "./nested.vue?vue&type=template&id=23001c98&scoped=true&"
import script from "./nested.vue?vue&type=script&lang=js&"
export * from "./nested.vue?vue&type=script&lang=js&"
import style0 from "./nested.vue?vue&type=style&index=0&id=23001c98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23001c98",
  null
  
)

export default component.exports